import { Icon } from '@alifd/next';
import * as React from 'react';
import { useEffect } from 'react';

const ICON_URL =
  '//cdn.appthen.com/editor/npm/@alilc/lowcode-engine-ext/1.0.7/font/font_2761185_ccl8ob63gmj.js';

let CustomIcon: any;

// document.addEventListener('DOMContentLoaded', function () {
//   // @ts-ignore
//   console.log('window.OEM_CONFIG: ', JSON.stringify(window.OEM_CONFIG));
//   CustomIcon = Icon.createFromIconfontCN({
//     // @ts-ignore
//     scriptUrl: window.OEM_CONFIG?.cdnDomain
//       ? ICON_URL.replace('cdn.appthen.com', window.OEM_CONFIG?.cdnDomain)
//       : ICON_URL,
//   });
// });

interface IconProps {
  type: string;
  size?: number | 'small' | 'xxs' | 'xs' | 'medium' | 'large' | 'xl' | 'xxl' | 'xxxl' | 'inherit';
  className?: string;
  style?: any;
}

export default (props: IconProps) => {
  const { type, size, className = '', style = {} } = props;
  useEffect(() => {
    if (!CustomIcon) {
      // @ts-ignore
      console.log('window.OEM_CONFIG: ', JSON.stringify(window.OEM_CONFIG));
      CustomIcon = Icon.createFromIconfontCN({
        // @ts-ignore
        scriptUrl: window.OEM_CONFIG?.cdnDomain
          ? ICON_URL.replace('cdn.appthen.com', window.OEM_CONFIG?.cdnDomain)
          : ICON_URL,
      });
    }
  }, []);
  return (
    <>{CustomIcon && <CustomIcon type={type} size={size} className={className} style={style} />}</>
  );
};
